import highchartsBasics from '@/language/pt/mixins/highcharts-basics';
import exportModel from '@/language/pt/mixins/export-model';
import pagesModel from '@/language/pt/mixins/pages-model';
import formModel from '@/language/pt/mixins/form-model';
import genderModel from '@/language/pt/mixins/gender-model';
import cardsModel from '@/language/pt/mixins/cards-model';
import statusModel from '@/language/pt/mixins/status-model';
import filtersModel from '@/language/pt/mixins/filters-model';
import sentimentModel from '@/language/pt/mixins/sentiment-model';
import deviceModel from '@/language/pt/mixins/device-model';
import channelModel from '@/language/pt/mixins/channel-model';
import sacTypeModel from '@/language/pt/mixins/sac-type-model';

export default {
  highchartsBasics,
  exportModel,
  pagesModel,
  formModel,
  genderModel,
  cardsModel,
  statusModel,
  filtersModel,
  sentimentModel,
  deviceModel,
  channelModel,
  sacTypeModel,
};
